import React, { Suspense } from 'react';

import { Route, Routes as ReactRoutes, useLocation } from 'react-router-dom';

import ProtectedRoute from './ProtectedRoute';

const HomePage = React.lazy(() => import('containers/Homepage'));
const OptIn = React.lazy(() => import('containers/OptIn'));
const OTP = React.lazy(() => import('containers/OTP'));
const DOB = React.lazy(() => import('containers/DOB'));
const PatientForm = React.lazy(() => import('containers/Form'));
const Page404 = React.lazy(() => import('containers/Page404'));
const IVRQuestionnaire = React.lazy(
    () => import('containers/IVRQuestionnaire')
);
const Patient = React.lazy(() => import('containers/PatientForm'));
const Loading = React.lazy(() => import('components/Loading'));
const StatusScreen = React.lazy(() => import('containers/StatusScreen'));
const Reply = React.lazy(() => import('containers/Reply'));
// const Privacy = React.lazy(() => import('containers/Privacy'));
// const TOS = React.lazy(() => import('containers/TOS'));
// const Steps = React.lazy(() => import('containers/Steps'));

function Routes() {
    const location = useLocation();
    return (
        <ReactRoutes>
            <Route
                key="body"
                path="/:partnerId/:requestId?/home"
                element={
                    <Suspense fallback={<Loading />}>
                        <HomePage />
                    </Suspense>
                }
            />
            <Route
                key="OptIn"
                path="/:partnerId/:requestId?/optin"
                element={
                    <Suspense fallback={<Loading />}>
                        <OptIn />
                    </Suspense>
                }
            />
            <Route
                key="otp"
                path="/:partnerId/:requestId?/otp"
                element={
                    <Suspense fallback={<Loading />}>
                        <OTP />
                    </Suspense>
                }
            />
            <Route
                key="wmaMap"
                path="/:partnerId/:requestId?/wma-map"
                element={
                    <Suspense fallback={<Loading />}>
                        <IVRQuestionnaire key={location.key} />
                    </Suspense>
                }
            />
            {/* <Route
                key="patientForm"
                path="/:partnerId/patient-form"
                element={
                    <Suspense fallback={<Loading />}>
                        <Patient />
                    </Suspense>
                }
            /> */}
            <Route
                key="patientForm"
                path="/:partnerId/:requestId?/patient-form"
                element={
                    <Suspense fallback={<Loading />}>
                        <Patient />
                    </Suspense>
                }
            />

            <Route
                key="statusScreen"
                path="/:partnerId/:requestId/status"
                element={
                    <Suspense fallback={<Loading />}>
                        <ProtectedRoute>
                            <StatusScreen />
                        </ProtectedRoute>
                    </Suspense>
                }
            />
            <Route
                key="reply"
                path="/:partnerId/:requestId/reply"
                element={
                    <Suspense fallback={<Loading />}>
                        <ProtectedRoute>
                            <Reply />
                        </ProtectedRoute>
                    </Suspense>
                }
            />
            <Route
                key="dob"
                path="/:partnerId/:requestId/dob"
                element={
                    <Suspense fallback={<Loading />}>
                        <DOB />
                    </Suspense>
                }
            />
            {/* <Route
                key="privacy"
                path="/privacy"
                element={
                    <Suspense fallback={<Loading />}>
                        <Privacy />
                    </Suspense>
                }
            />
            <Route
                key="tos"
                path="/tos"
                element={
                    <Suspense fallback={<Loading />}>
                        <TOS />
                    </Suspense>
                }
            /> */}

            {/*  <Route
                key="steps"
                path="/:partnerId/:requestId/steps"
                element={
                    <Suspense fallback={<Loading />}>
                        <Steps />
                    </Suspense>
                }
            />
            <Route
                key="patient-form"
                path="/:partnerId/:requestId/patient-form"
                element={
                    <Suspense fallback={<Loading />}>
                        <PatientForm />
                    </Suspense>
                }
            />
            <Route
                key="status"
                path="/:partnerId/:requestId/status"
                element={
                    <Suspense fallback={<Loading />}>
                        <Status />
                    </Suspense>
                }
            /> */}
            <Route
                key="error"
                path="/error/:type"
                element={
                    <Suspense fallback={<Loading />}>
                        <Page404 />
                    </Suspense>
                }
            />
        </ReactRoutes>
    );
}

export default Routes;
